import locale from 'localization';

export const transactionColumns = [
  { key: 'rowNo', text: 'Row', width: '5%' },
  { key: 'transactionId', text: `Transaction ID`, width: '7%' },
  { key: 'customerAccountNumber', text: 'Account Number', width: '12%' },
  { key: 'type', text: 'Type', width: '8%' },
  { key: 'amount', text: 'Amount', width: '12%' },
  { key: 'balance', text: 'Old Balance', width: '10%' },
  { key: 'newBalance', text: 'New Balance', width: '10%' },
  { key: 'status', text: 'Status', width: '10%' },
  { key: 'createdAt', text: locale.dateOfTransaction, width: '10%' },
  { key: 'transactedBy', text: `Transacted By`, width: '12%' },
  { key: 'options', text: '', width: '5%' }
];
